import { Component, Input, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { AlertService } from '@services/alert.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'mdk-app-header',
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  @Input() title: string = 'MDK Application';
  headerLogoUrl: string = '';
  isUserAuthenticated: boolean = false;
  isAuthSessionLoading: boolean = false;

  constructor(private authService: AuthenticationService) {}

  ngOnInit(): void {
    this.isAuthSessionLoading = true;
    this.authService.isUserAuthenticated$
      .pipe(
        finalize(() => {
          this.isAuthSessionLoading = false;
        })
      )
      .subscribe({
        next: (isAuthenticated: boolean) => {
          this.isUserAuthenticated = isAuthenticated;

          if (!isAuthenticated) {
            // Auto redirect when not logged in
            this.authService.login();
          }
        },
        error: (error) => {
          // Only unexpected errors end up here
          console.warn(
            `Unexpected error while loading authentication session. Please report to the developer if the issue persists. Header: ${error.message}`
          );
        },
      });
  }

  onLoginButtonClick(): void {
    this.authService.login();
  }
}
